import { render, staticRenderFns } from "./manageUploadedUsersDialog.vue?vue&type=template&id=4c4c64a4&"
import script from "./manageUploadedUsersDialog.vue?vue&type=script&lang=js&"
export * from "./manageUploadedUsersDialog.vue?vue&type=script&lang=js&"
import style0 from "./manageUploadedUsersDialog.vue?vue&type=style&index=0&lang=stylus&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports